/**
 * Canonical identity of the public marketing site. Lives in `shared` because
 * both the web bundle and the API (which renders article `<head>` metadata at
 * request time) have to agree on the origin every canonical URL is built from.
 */
export const SITE_ORIGIN = 'https://wanderlustcravings.com';
export const SITE_NAME = 'Wanderlust Cravings';
